export class BaseCart {
    constructor() {
        this.storageKey = "_lora_metadata"
    }

    persistCartProperties(variantId, properties) {
        const metadata = JSON.parse(localStorage.getItem(this.storageKey) ?? "{}")
        metadata[variantId] = properties
        localStorage.setItem(this.storageKey, JSON.stringify(metadata))
    }

    deleteCartProperties(variantId) {
        const metadata = JSON.parse(localStorage.getItem(this.storageKey) ?? "{}")
        delete metadata[variantId]
        localStorage.setItem(this.storageKey, JSON.stringify(metadata))
    }

    getCartProperties(variantId) {
        const metadata = JSON.parse(localStorage.getItem(this.storageKey) ?? "{}")
        return metadata[variantId] ?? {}
    }

    syncCartProperties(cartState) {
        const metadata = JSON.parse(localStorage.getItem(this.storageKey) ?? "{}")
        for (const variantId in metadata) {
            if (!cartState.some((item) => item.id === variantId)) {
                delete metadata[variantId]
            }
        }
        localStorage.setItem(this.storageKey, JSON.stringify(metadata))
    }
}
